import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";































import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";










export const initialFormStateFn = () => { return {
    
        
        address: "",
        
    
        
        city: "",
        
    
        
        country: "",
        
    
        
        email: "",
        
    
        
        phone: "",
        
    
        
        mobilePhone: "",
        
    
        
        description: "",
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        address:
        string()
        .trim()
        .nullish(),
    
    
        city:
        string()
        .trim()
        .nullish(),
    
    
        country:
        string()
        .trim()
        .nullish(),
    
    
        email:
        string()
        .trim()
        .nullish(),
    
    
        phone:
        string()
        .trim()
        .nullish(),
    
    
        mobilePhone:
        string()
        .trim()
        .nullish(),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);

const AddressAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'address' }
       aria-label="address"
       data-testid="address"
       label={t`Address`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'city' }
       aria-label="city"
       data-testid="city"
       label={t`City`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'country' }
       aria-label="country"
       data-testid="country"
       label={t`Country`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'email' }
       aria-label="email"
       data-testid="email"
       label={t`Email`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'phone' }
       aria-label="phone"
       data-testid="phone"
       label={t`Phone`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'mobilePhone' }
       aria-label="mobilePhone"
       data-testid="mobilePhone"
       label={t`Mobile Phone`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
           
        </Container>
    )
}

export default AddressAddForm;
